import { HOME_TABS } from "../constants";

type TabsProps = {
  selectedTab: number;
  setSelectedTab: (index: number) => void;
};

const Tabs = ({ selectedTab, setSelectedTab }: TabsProps) => {
  return (
    <div className='tabs'>
      {HOME_TABS.map((tab: any, index: any) => (
        <button
          key={tab.id}
          className={selectedTab === index ? "active" : ""}
          style={{
            marginLeft: tab.name === "About" ? "auto" : "",
          }}
          onClick={() => setSelectedTab(index)}
        >
          {tab.name}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
